import React, { useState, useEffect } from 'react';

export default function CompliancePage({ apiUrl }) {
  const [compliance, setCompliance] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${apiUrl}/api/compliance`)
      .then(r => r.json())
      .then(d => { setCompliance(d); setLoading(false); })
      .catch(e => { console.error(e); setLoading(false); });
  }, [apiUrl]);

  if (loading) return <div style={{ padding: '20px' }}>Loading...</div>;

  return <div style={{ padding: '20px' }}><h1>Compliance</h1><p>Total Checks: {compliance.length}</p></div>;
}